import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { OrganizationService } from '../services/organization.service';
import { EventDialogComponent, EventDialogResult } from '../event-dialog/event-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { InterestOptions } from 'src/shared/constants/interestOptions';
import { EventsListComponent } from '../events-list/events-list.component';
import { AdminService } from '../services/admin.service';
import { UserService } from '../services/user.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-vieworg',
  templateUrl: './vieworg.component.html',
  styleUrls: ['./vieworg.component.css']
})
export class VieworgComponent implements OnInit {
  @ViewChild(EventsListComponent) eventsList!: EventsListComponent;

  downloadURL: any;
  categories: String[] = [];
  interestOptions: { [key: string]: string } = InterestOptions;
  interestKeys: string[] = Object.keys(this.interestOptions);
  interests: string[] | undefined;

  private activeOrg = "";

  public name: string = "";
  public desciption: string = "";

  public isUser = false;
  public isOrg = false;
  public isAdmin = false;


  constructor(
    private dialog: MatDialog,
    private authService: AuthenticationService,
    private adminService: AdminService,
    private orgService: OrganizationService,
    private userService: UserService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.authService.setSignedIn(true);

    setTimeout(() => this.authService.CheckPrivileges(), 1000)
    setTimeout(() => this.isAdmin = this.adminService.getAdminStatus(), 2000)
    setTimeout(() => this.isUser = this.userService.getUserStatus(), 2000)
    setTimeout(() => this.isOrg = this.orgService.getOrgStatus(), 2000)

    setTimeout(() => console.log(this.isAdmin, this.isUser, this.isOrg), 3000)

    this.getOrg();
  }

  async getOrg() {
    const routeParams = this.route.snapshot.paramMap;
    this.activeOrg = routeParams.get("org") ?? "";
    console.log(this.activeOrg)

    let org = await this.orgService.getOrg(this.activeOrg);
    if (org) {
      this.name = org.name;
      this.interests = org.tags;
      this.desciption = org.description;
    }
  }

  ngAfterViewInit() {
    this.refreshEvents();
  }

  refreshEvents(): void {
    this.eventsList.refreshEvents(undefined, this.interests)
  }

  newEvent(): void {
    const dialogRef = this.dialog.open(EventDialogComponent, {
      width: '300px',
      data: {
        event: {},
      },
    });

    dialogRef
      .afterClosed()
      .subscribe((result: EventDialogResult | undefined) => {
        if (!result) {
          return;
        }
        this.refreshEvents();
      })
  }
}
